import {
  Array,
  Literal,
  Optional,
  Record,
  String,
  Union,
  Unknown
} from 'runtypes'
import { HeroBannerButtonItem } from './HeroBanner/HeroBanner.types'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type HeroBannerContainerProps = {
  props: {
    des?: string
    complement?: string
    buttons?: HeroBannerButtonItem[]
    backgroundImageUrl?: string
    backgroundImageUrlMobile?: string
    imageAlt?: string
    desColor?: string
    complementColor?: string
    styleMap?: StyleMap
  }
}

const LinkButtonTypeGuard = Record({
  label: String,
  href: String,
  target: Optional(String)
})

const PublicButtonTypeGuard = Record({
  type: Literal('public')
})

const ButtonTypeGuard = Union(LinkButtonTypeGuard, PublicButtonTypeGuard)

export const HeroBannerContainerTypeGuard = Record({
  des: Optional(String),
  complement: Optional(String),
  buttons: Optional(Array(ButtonTypeGuard)),
  backgroundImageUrl: Optional(String),
  backgroundImageUrlMobile: Optional(String),
  imageAlt: Optional(String),
  desColor: Optional(String),
  complementColor: Optional(String),
  styleMap: Optional(Unknown)
})
